<template>
  <v-container data-aos="fade">
    <v-layout row wrap justify-space-around>
      <v-flex xs12 sm4>
        <v-img :src="image" class="elevation-2 flyer"></v-img>
        <v-btn color="primary" href="mailto:contact@chefnaturelle.com?subject=A Taste of Autumn">Book Now</v-btn>
      </v-flex>
      <v-flex xs12 sm7>
        <h1>A Taste of Autumn</h1>
        <v-layout class="pricing-details" row justify-space-between>
          <v-flex xs8 class="text-xs-left">
            Saturday 9th Nov 2019 - 7pm to 10pm - Hertford
          </v-flex>
          <v-flex xs4 class="text-xs-right">
            £35
          </v-flex>
        </v-layout>
        <p class="font-weight-bold">
          In this second Farm to Table dinner, we are getting cosy at the charming
          <a href="https://mudlarksgarden.org.uk/cafe/" target="_blank">Mudlarks Garden Café</a> to celebrate Autumn
          with a three-course meal featuring beautiful vegetables sourced from a local farm and our allotment.
        </p>

        <p>Bringing people together to enjoy the art of good food is at the heart of this dinner. A magical mix of:</p>
        <ul>
          <li>good food: using only the best quality and seasonal whole food ingredients, your meal will be
            prepared with love and passion
          </li>
          <li>good atmosphere: the beautiful Mudlarks Garden Café is a charming place synonymous of conviviality
            supporting people with disabilities
          </li>
          <li>good people to share it with: bring friends and family or come alone to meet other lovely people</li>
          <li>good wine: matching wines have been selected by the very knowledgable wine specialist at
            <a href="https://www.cavavin.co.uk" target="_blank">Cavavin</a> to compliment the menu and are available
            to buy separately from <a href="https://www.cavavin.co.uk/contact/" target="_blank">their shop</a>
            (full details and tasting notes will be provided upon booking). You are also welcome to bring other
            alcoholic or non-alcoholic drinks. Wine glasses will be provided - no corkage fee!
          </li>
        </ul>
        <p>
          We will welcome you at 7pm with a drink and amuse-bouche. You will have a little time to get comfy and get
          to know the other guests before finding your seat and discovering the menu, especially designed to
          showcase local and seasonal produce! It will then be time to eat and tuck into a delicious three course
          plant-based meal.
        </p>
        <p>Tickets are £35 per person and include a welcome drink, amuse-bouche and a three-course meal.</p>
        <p class="font-weight-bold">Booking is essential - email
          <Contact subject="A Taste of Autumn"></Contact>
          to book your seat.
        </p>
        <p>See you at the table!</p>
        <div class="terms">
          <p>Please note that sittings and bathroom are located on the first floor with no lift.</p>
          <p>This event is not suitable for anyone suffering from food allergies. as the food is freshly prepared
            in a kitchen which uses wheat, rye, barley, oats, nuts (including peanuts), seeds (including sesame),
            soybeans and other allergens. If you have any food intolerances,
            please <contact-link subject="A Taste of Autumn"></contact-link>
            before booking and we will be happy to discuss alternatives.
          </p>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ContactLink from '@/components/ContactLink'
import Contact from '@/components/Contact'

export default {
  components: {
    Contact,
    ContactLink
  },
  data: () => ({
    image: require('@/assets/images/a-taste-of-autumn.jpg?vuetify-preload')
  })
}
</script>

<style scoped>
h1 {
  color: rgb(255,147,0);
  font-family: 'Karla', sans-serif;
  font-weight: bold;
  text-transform: none;
  font-size: 40px;
}

.flyer {
  margin-bottom: 15px;
}

.underline {
  text-decoration: underline;
}

.terms p {
  font-size: 15px;
  font-style: italic;
}

.pricing-details {
  color: rgb(255,147,0);
  border-bottom: 1px solid rgb(255,147,0);
  margin-bottom: 23px;
  padding-bottom: 20px;
  text-transform: uppercase;
  font-weight: bold;
}

.v-image {
  margin-top: 14px;
}

strong {
  color: rgb(255,147,0);
  font-size: 25px;
}
</style>
